import Component from '../../components/component/component';

import 'slick-carousel';

import 'slick-carousel/slick/slick.scss';
import './carousel.scss';

const ANIMATION_DURATION: number = 200;

export default class Carousel extends Component {
    static initSelector: string = '.js-carousel';

    public images: JQuery;
    private contentCarousel: JQuery;
    private carouselAttributes: JQuerySlickOptions;
    private timeout: ReturnType<typeof setTimeout>;

    constructor(target: HTMLElement) {
        super(target);

        this.contentCarousel = this.element.find('.carousel__content');
        this.images = this.element.find('.carousel__logo-image .image__img');

        this.carouselAttributes = {
            adaptiveHeight: true,
            arrows: false,
            autoplay: false,
            draggable: false,
            fade: true,
            infinite: true,
            slidesToShow: 1,
            speed: ANIMATION_DURATION,
            swipe: false,
        };

        this.init();
    }

    init(): void {
        if (this.contentCarousel.length && !this.contentCarousel.hasClass('slick-initialized')) {
            this.contentCarousel.slick(this.carouselAttributes);

            this.contentCarousel.on('beforeChange', this.onBeforeChange.bind(this));
        }

        const observer: MutationObserver = new MutationObserver(() => {
            this.contentCarousel.slick('setPosition');
        });

        this.images.each((_index: number, element: HTMLElement) => {
            const target: JQuery = $(element);

            observer.observe(target[0], {
                attributeFilter: ['class'],
                attributes: true,
                characterData: false,
                childList: false,
            });
        });
    }

    onBeforeChange(_event: JQuery.Event, slick: JQuerySlick, _currentSlideIndex: number, nextSlideIndex: number): void {
        const nextSlide: JQuery = $(slick.$slides[nextSlideIndex]);
        const list: JQuery = $(slick.$list);

        // To manually change carousel height from now on:
        this.contentCarousel.slick('slickSetOption', 'adaptiveHeight', false, false);

        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        // Wait to fade-out before animating height:
        this.timeout = setTimeout(() => {
            list.stop().animate({
                height: nextSlide.innerHeight(),
            }, ANIMATION_DURATION, () => {
                // Set height back to adaptive for responsiveness:
                this.contentCarousel.slick('slickSetOption', 'adaptiveHeight', true, false);
            });
        }, ANIMATION_DURATION);
    }
}
